import * as CX from './Concept';

export const RELATIONSHIPS_ALLOWED_FROM_APPLICATION_COLLABORATION = new Map([
	[CX.MOTIVATION_ASSESSMENT, 'no'],
	[CX.MOTIVATION_CONSTRAINT, 'rno'],
	[CX.MOTIVATION_DRIVER, 'no'],
	[CX.MOTIVATION_GOAL, 'rno'],
	[CX.MOTIVATION_MEANING, 'no'],
	[CX.MOTIVATION_OUTCOME, 'rno'],
	[CX.MOTIVATION_PRINCIPLE, 'rno'],
	[CX.MOTIVATION_REQUIREMENT, 'rno'],
	[CX.MOTIVATION_STAKEHOLDER, 'no'],
	[CX.MOTIVATION_VALUE, 'no'],
	[CX.STRATEGY_CAPABILITY, 'ro'],
	[CX.STRATEGY_VALUE_STREAM, 'ro'],
	[CX.STRATEGY_COURSE_OF_ACTION, 'ro'],
	[CX.STRATEGY_RESOURCE, 'ro'],
	[CX.BUSINESS_ACTOR, 'vtfo'],
	[CX.BUSINESS_COLLABORATION, 'vtfo'],
	[CX.BUSINESS_EVENT, 'rvtfo'],
	[CX.BUSINESS_FUNCTION, 'rvtfo'],
	[CX.BUSINESS_INTERACTION, 'rvtfo'],
	[CX.BUSINESS_INTERFACE, 'rvtfo'],
	[CX.BUSINESS_OBJECT, 'ao'],
	[CX.BUSINESS_PROCESS, 'rvtfo'],
	[CX.BUSINESS_ROLE, 'vtfo'],
	[CX.BUSINESS_SERVICE, 'rvtfo'],
	[CX.BUSINESS_CONTRACT, 'ao'],
	[CX.BUSINESS_PRODUCT, 'vtfo'],
	[CX.BUSINESS_REPRESENTATION, 'ao'],
	[CX.APPLICATION_COLLABORATION, 'scgvtfo'],
	[CX.APPLICATION_COMPONENT, 'grvtfo'],
	[CX.APPLICATION_EVENT, 'irvtfo'],
	[CX.APPLICATION_FUNCTION, 'irvtfo'],
	[CX.APPLICATION_INTERACTION, 'irvtfo'],
	[CX.APPLICATION_INTERFACE, 'cgrvtfo'],
	[CX.APPLICATION_PROCESS, 'irvtfo'],
	[CX.APPLICATION_SERVICE, 'fiortv'],
	[CX.APPLICATION_DATA_OBJECT, 'ao'],
	[CX.TECHNOLOGY_ARTIFACT, 'ao'],
	[CX.TECHNOLOGY_COMMUNICATION_NETWORK, 'vtfo'],
	[CX.TECHNOLOGY_DEVICE, 'vtfo'],
	[CX.TECHNOLOGY_NODE, 'vtfo'],
	[CX.TECHNOLOGY_PATH, 'vtfo'],
	[CX.TECHNOLOGY_SYSTEM_SOFTWARE, 'vtfo'],
	[CX.TECHNOLOGY_COLLABORATION, 'vtfo'],
	[CX.TECHNOLOGY_EVENT, 'vtfo'],
	[CX.TECHNOLOGY_FUNCTION, 'vtfo'],
	[CX.TECHNOLOGY_INTERACTION, 'vtfo'],
	[CX.TECHNOLOGY_INTERFACE, 'vtfo'],
	[CX.TECHNOLOGY_PROCESS, 'vtfo'],
	[CX.TECHNOLOGY_SERVICE, 'vtfo'],
	[CX.PHYSICAL_DISTRIBUTION_NETWORK, 'vtfo'],
	[CX.PHYSICAL_EQUIPMENT, 'vtfo'],
	[CX.PHYSICAL_FACILITY, 'vtfo'],
	[CX.PHYSICAL_MATERIAL, 'ao'],
	[CX.IMP_MIG_DELIVERABLE, 'o'],
	[CX.IMP_MIG_IMPLEMENTATION_EVENT, 'o'],
	[CX.IMP_MIG_WORK_PACKAGE, 'o'],
	[CX.IMP_MIG_GAP, 'o'],
	[CX.IMP_MIG_PLATEAU, 'o'],
	[CX.OTHER_LOCATION, 'vtfo'],
	[CX.OTHER_GROUPING, 'scgirvantfo'],
	[CX.OTHER_JUNCTION, 'cgirvantfso'],
	[CX.OTHER_AND_JUNCTION, 'cgirvantfso'],
	[CX.OTHER_OR_JUNCTION, 'cgirvantfso'],
	[CX.RELATIONSHIP_ACCESS, 'o'],
	[CX.RELATIONSHIP_AGGREGATION, 'o'],
	[CX.RELATIONSHIP_ASSIGNMENT, 'o'],
	[CX.RELATIONSHIP_ASSOCIATION, 'o'],
	[CX.RELATIONSHIP_COMPOSITION, 'o'],
	[CX.RELATIONSHIP_FLOW, 'o'],
	[CX.RELATIONSHIP_INFLUENCE, 'o'],
	[CX.RELATIONSHIP_JUNCTION_AND, 'o'],
	[CX.RELATIONSHIP_JUNCTION_OR, 'o'],
	[CX.RELATIONSHIP_REALIZATION, 'o'],
	[CX.RELATIONSHIP_SERVING, 'o'],
	[CX.RELATIONSHIP_SPECIALIZATION, 'o'],
	[CX.RELATIONSHIP_TRIGGERING, 'o'],
]);

export const RELATIONSHIPS_ALLOWED_FROM_APPLICATION_COMPONENT = new Map([
	[CX.MOTIVATION_ASSESSMENT, 'no'],
	[CX.MOTIVATION_CONSTRAINT, 'rno'],
	[CX.MOTIVATION_DRIVER, 'no'],
	[CX.MOTIVATION_GOAL, 'rno'],
	[CX.MOTIVATION_MEANING, 'no'],
	[CX.MOTIVATION_OUTCOME, 'rno'],
	[CX.MOTIVATION_PRINCIPLE, 'rno'],
	[CX.MOTIVATION_REQUIREMENT, 'rno'],
	[CX.MOTIVATION_STAKEHOLDER, 'no'],
	[CX.MOTIVATION_VALUE, 'no'],
	[CX.STRATEGY_CAPABILITY, 'ro'],
	[CX.STRATEGY_VALUE_STREAM, 'ro'],
	[CX.STRATEGY_COURSE_OF_ACTION, 'ro'],
	[CX.STRATEGY_RESOURCE, 'ro'],
	[CX.BUSINESS_ACTOR, 'vtfo'],
	[CX.BUSINESS_COLLABORATION, 'vtfo'],
	[CX.BUSINESS_EVENT, 'rvtfo'],
	[CX.BUSINESS_FUNCTION, 'rvtfo'],
	[CX.BUSINESS_INTERACTION, 'rvtfo'],
	[CX.BUSINESS_INTERFACE, 'rvtfo'],
	[CX.BUSINESS_OBJECT, 'ao'],
	[CX.BUSINESS_PROCESS, 'rvtfo'],
	[CX.BUSINESS_ROLE, 'vtfo'],
	[CX.BUSINESS_SERVICE, 'rvtfo'],
	[CX.BUSINESS_CONTRACT, 'ao'],
	[CX.BUSINESS_PRODUCT, 'vtfo'],
	[CX.BUSINESS_REPRESENTATION, 'ao'],
	[CX.APPLICATION_COLLABORATION, 'vtfo'],
	[CX.APPLICATION_COMPONENT, 'scgrvtfo'],
	[CX.APPLICATION_EVENT, 'irvtfo'],
	[CX.APPLICATION_FUNCTION, 'irvtfo'],
	[CX.APPLICATION_INTERACTION, 'irvtfo'],
	[CX.APPLICATION_INTERFACE, 'cgrvtfo'],
	[CX.APPLICATION_PROCESS, 'irvtfo'],
	[CX.APPLICATION_SERVICE, 'fiortv'],
	[CX.APPLICATION_DATA_OBJECT, 'ao'],
	[CX.TECHNOLOGY_ARTIFACT, 'ao'],
	[CX.TECHNOLOGY_COMMUNICATION_NETWORK, 'vtfo'],
	[CX.TECHNOLOGY_DEVICE, 'vtfo'],
	[CX.TECHNOLOGY_NODE, 'vtfo'],
	[CX.TECHNOLOGY_PATH, 'vtfo'],
	[CX.TECHNOLOGY_SYSTEM_SOFTWARE, 'vtfo'],
	[CX.TECHNOLOGY_COLLABORATION, 'vtfo'],
	[CX.TECHNOLOGY_EVENT, 'vtfo'],
	[CX.TECHNOLOGY_FUNCTION, 'vtfo'],
	[CX.TECHNOLOGY_INTERACTION, 'vtfo'],
	[CX.TECHNOLOGY_INTERFACE, 'vtfo'],
	[CX.TECHNOLOGY_PROCESS, 'vtfo'],
	[CX.TECHNOLOGY_SERVICE, 'vtfo'],
	[CX.PHYSICAL_DISTRIBUTION_NETWORK, 'vtfo'],
	[CX.PHYSICAL_EQUIPMENT, 'vtfo'],
	[CX.PHYSICAL_FACILITY, 'vtfo'],
	[CX.PHYSICAL_MATERIAL, 'ao'],
	[CX.IMP_MIG_DELIVERABLE, 'o'],
	[CX.IMP_MIG_IMPLEMENTATION_EVENT, 'o'],
	[CX.IMP_MIG_WORK_PACKAGE, 'o'],
	[CX.IMP_MIG_GAP, 'o'],
	[CX.IMP_MIG_PLATEAU, 'o'],
	[CX.OTHER_LOCATION, 'vtfo'],
	[CX.OTHER_GROUPING, 'scgirvantfo'],
	[CX.OTHER_JUNCTION, 'cgirvantfso'],
	[CX.OTHER_AND_JUNCTION, 'cgirvantfso'],
	[CX.OTHER_OR_JUNCTION, 'cgirvantfso'],
	[CX.RELATIONSHIP_ACCESS, 'o'],
	[CX.RELATIONSHIP_AGGREGATION, 'o'],
	[CX.RELATIONSHIP_ASSIGNMENT, 'o'],
	[CX.RELATIONSHIP_ASSOCIATION, 'o'],
	[CX.RELATIONSHIP_COMPOSITION, 'o'],
	[CX.RELATIONSHIP_FLOW, 'o'],
	[CX.RELATIONSHIP_INFLUENCE, 'o'],
	[CX.RELATIONSHIP_JUNCTION_AND, 'o'],
	[CX.RELATIONSHIP_JUNCTION_OR, 'o'],
	[CX.RELATIONSHIP_REALIZATION, 'o'],
	[CX.RELATIONSHIP_SERVING, 'o'],
	[CX.RELATIONSHIP_SPECIALIZATION, 'o'],
	[CX.RELATIONSHIP_TRIGGERING, 'o'],
]);

export const RELATIONSHIPS_ALLOWED_FROM_APPLICATION_EVENT = new Map([
	[CX.MOTIVATION_ASSESSMENT, 'no'],
	[CX.MOTIVATION_CONSTRAINT, 'rno'],
	[CX.MOTIVATION_DRIVER, 'no'],
	[CX.MOTIVATION_GOAL, 'rno'],
	[CX.MOTIVATION_MEANING, 'no'],
	[CX.MOTIVATION_OUTCOME, 'rno'],
	[CX.MOTIVATION_PRINCIPLE, 'rno'],
	[CX.MOTIVATION_REQUIREMENT, 'rno'],
	[CX.MOTIVATION_STAKEHOLDER, 'no'],
	[CX.MOTIVATION_VALUE, 'no'],
	[CX.STRATEGY_CAPABILITY, 'o'],
	[CX.STRATEGY_VALUE_STREAM, 'o'],
	[CX.STRATEGY_COURSE_OF_ACTION, 'o'],
	[CX.STRATEGY_RESOURCE, 'o'],
	[CX.BUSINESS_ACTOR, 'vtfo'],
	[CX.BUSINESS_COLLABORATION, 'vtfo'],
	[CX.BUSINESS_EVENT, 'rvtfo'],
	[CX.BUSINESS_FUNCTION, 'vtfo'],
	[CX.BUSINESS_INTERACTION, 'vtfo'],
	[CX.BUSINESS_INTERFACE, 'vtfo'],
	[CX.BUSINESS_OBJECT, 'ao'],
	[CX.BUSINESS_PROCESS, 'vtfo'],
	[CX.BUSINESS_ROLE, 'vtfo'],
	[CX.BUSINESS_SERVICE, 'vtfo'],
	[CX.BUSINESS_CONTRACT, 'ao'],
	[CX.BUSINESS_PRODUCT, 'vtfo'],
	[CX.BUSINESS_REPRESENTATION, 'ao'],
	[CX.APPLICATION_COLLABORATION, 'vtfo'],
	[CX.APPLICATION_COMPONENT, 'vtfo'],
	[CX.APPLICATION_EVENT, 'scgvtfo'],
	[CX.APPLICATION_FUNCTION, 'vtfo'],
	[CX.APPLICATION_INTERACTION, 'vtfo'],
	[CX.APPLICATION_INTERFACE, 'vtfo'],
	[CX.APPLICATION_PROCESS, 'vtfo'],
	[CX.APPLICATION_SERVICE, 'vtfo'],
	[CX.APPLICATION_DATA_OBJECT, 'ao'],
	[CX.TECHNOLOGY_ARTIFACT, 'ao'],
	[CX.TECHNOLOGY_COMMUNICATION_NETWORK, 'vtfo'],
	[CX.TECHNOLOGY_DEVICE, 'vtfo'],
	[CX.TECHNOLOGY_NODE, 'vtfo'],
	[CX.TECHNOLOGY_PATH, 'vtfo'],
	[CX.TECHNOLOGY_SYSTEM_SOFTWARE, 'vtfo'],
	[CX.TECHNOLOGY_COLLABORATION, 'vtfo'],
	[CX.TECHNOLOGY_EVENT, 'vtfo'],
	[CX.TECHNOLOGY_FUNCTION, 'vtfo'],
	[CX.TECHNOLOGY_INTERACTION, 'vtfo'],
	[CX.TECHNOLOGY_INTERFACE, 'vtfo'],
	[CX.TECHNOLOGY_PROCESS, 'vtfo'],
	[CX.TECHNOLOGY_SERVICE, 'vtfo'],
	[CX.PHYSICAL_DISTRIBUTION_NETWORK, 'vtfo'],
	[CX.PHYSICAL_EQUIPMENT, 'vtfo'],
	[CX.PHYSICAL_FACILITY, 'vtfo'],
	[CX.PHYSICAL_MATERIAL, 'ao'],
	[CX.IMP_MIG_DELIVERABLE, 'o'],
	[CX.IMP_MIG_IMPLEMENTATION_EVENT, 'o'],
	[CX.IMP_MIG_WORK_PACKAGE, 'o'],
	[CX.IMP_MIG_GAP, 'o'],
	[CX.IMP_MIG_PLATEAU, 'o'],
	[CX.OTHER_LOCATION, 'vtfo'],
	[CX.OTHER_GROUPING, 'scgrvantfo'],
	[CX.OTHER_JUNCTION, 'cgirvantfso'],
	[CX.OTHER_AND_JUNCTION, 'cgirvantfso'],
	[CX.OTHER_OR_JUNCTION, 'cgirvantfso'],
	[CX.RELATIONSHIP_ACCESS, 'o'],
	[CX.RELATIONSHIP_AGGREGATION, 'o'],
	[CX.RELATIONSHIP_ASSIGNMENT, 'o'],
	[CX.RELATIONSHIP_ASSOCIATION, 'o'],
	[CX.RELATIONSHIP_COMPOSITION, 'o'],
	[CX.RELATIONSHIP_FLOW, 'o'],
	[CX.RELATIONSHIP_INFLUENCE, 'o'],
	[CX.RELATIONSHIP_JUNCTION_AND, 'o'],
	[CX.RELATIONSHIP_JUNCTION_OR, 'o'],
	[CX.RELATIONSHIP_REALIZATION, 'o'],
	[CX.RELATIONSHIP_SERVING, 'o'],
	[CX.RELATIONSHIP_SPECIALIZATION, 'o'],
	[CX.RELATIONSHIP_TRIGGERING, 'o'],
]);

export const RELATIONSHIPS_ALLOWED_FROM_APPLICATION_FUNCTION = new Map([
	[CX.MOTIVATION_ASSESSMENT, 'no'],
	[CX.MOTIVATION_CONSTRAINT, 'rno'],
	[CX.MOTIVATION_DRIVER, 'no'],
	[CX.MOTIVATION_GOAL, 'rno'],
	[CX.MOTIVATION_MEANING, 'no'],
	[CX.MOTIVATION_OUTCOME, 'rno'],
	[CX.MOTIVATION_PRINCIPLE, 'rno'],
	[CX.MOTIVATION_REQUIREMENT, 'rno'],
	[CX.MOTIVATION_STAKEHOLDER, 'no'],
	[CX.MOTIVATION_VALUE, 'no'],
	[CX.STRATEGY_CAPABILITY, 'ro'],
	[CX.STRATEGY_VALUE_STREAM, 'ro'],
	[CX.STRATEGY_COURSE_OF_ACTION, 'ro'],
	[CX.STRATEGY_RESOURCE, 'o'],
	[CX.BUSINESS_ACTOR, 'vtfo'],
	[CX.BUSINESS_COLLABORATION, 'vtfo'],
	[CX.BUSINESS_EVENT, 'vtfo'],
	[CX.BUSINESS_FUNCTION, 'rvtfo'],
	[CX.BUSINESS_INTERACTION, 'rvtfo'],
	[CX.BUSINESS_INTERFACE, 'vtfo'],
	[CX.BUSINESS_OBJECT, 'ao'],
	[CX.BUSINESS_PROCESS, 'rvtfo'],
	[CX.BUSINESS_ROLE, 'vtfo'],
	[CX.BUSINESS_SERVICE, 'rvtfo'],
	[CX.BUSINESS_CONTRACT, 'ao'],
	[CX.BUSINESS_PRODUCT, 'vtfo'],
	[CX.BUSINESS_REPRESENTATION, 'ao'],
	[CX.APPLICATION_COLLABORATION, 'vtfo'],
	[CX.APPLICATION_COMPONENT, 'vtfo'],
	[CX.APPLICATION_EVENT, 'vtfo'],
	[CX.APPLICATION_FUNCTION, 'scgvtfo'],
	[CX.APPLICATION_INTERACTION, 'cgvtfo'],
	[CX.APPLICATION_INTERFACE, 'vtfo'],
	[CX.APPLICATION_PROCESS, 'cgvtfo'],
	[CX.APPLICATION_SERVICE, 'rvtfo'],
	[CX.APPLICATION_DATA_OBJECT, 'ao'],
	[CX.TECHNOLOGY_ARTIFACT, 'ao'],
	[CX.TECHNOLOGY_COMMUNICATION_NETWORK, 'vtfo'],
	[CX.TECHNOLOGY_DEVICE, 'vtfo'],
	[CX.TECHNOLOGY_NODE, 'vtfo'],
	[CX.TECHNOLOGY_PATH, 'vtfo'],
	[CX.TECHNOLOGY_SYSTEM_SOFTWARE, 'vtfo'],
	[CX.TECHNOLOGY_COLLABORATION, 'vtfo'],
	[CX.TECHNOLOGY_EVENT, 'vtfo'],
	[CX.TECHNOLOGY_FUNCTION, 'vtfo'],
	[CX.TECHNOLOGY_INTERACTION, 'vtfo'],
	[CX.TECHNOLOGY_INTERFACE, 'vtfo'],
	[CX.TECHNOLOGY_PROCESS, 'vtfo'],
	[CX.TECHNOLOGY_SERVICE, 'vtfo'],
	[CX.PHYSICAL_DISTRIBUTION_NETWORK, 'vtfo'],
	[CX.PHYSICAL_EQUIPMENT, 'vtfo'],
	[CX.PHYSICAL_FACILITY, 'vtfo'],
	[CX.PHYSICAL_MATERIAL, 'ao'],
	[CX.IMP_MIG_DELIVERABLE, 'o'],
	[CX.IMP_MIG_IMPLEMENTATION_EVENT, 'o'],
	[CX.IMP_MIG_WORK_PACKAGE, 'o'],
	[CX.IMP_MIG_GAP, 'o'],
	[CX.IMP_MIG_PLATEAU, 'o'],
	[CX.OTHER_LOCATION, 'vtfo'],
	[CX.OTHER_GROUPING, 'scgrvantfo'],
	[CX.OTHER_JUNCTION, 'cgirvantfso'],
	[CX.OTHER_AND_JUNCTION, 'cgirvantfso'],
	[CX.OTHER_OR_JUNCTION, 'cgirvantfso'],
	[CX.RELATIONSHIP_ACCESS, 'o'],
	[CX.RELATIONSHIP_AGGREGATION, 'o'],
	[CX.RELATIONSHIP_ASSIGNMENT, 'o'],
	[CX.RELATIONSHIP_ASSOCIATION, 'o'],
	[CX.RELATIONSHIP_COMPOSITION, 'o'],
	[CX.RELATIONSHIP_FLOW, 'o'],
	[CX.RELATIONSHIP_INFLUENCE, 'o'],
	[CX.RELATIONSHIP_JUNCTION_AND, 'o'],
	[CX.RELATIONSHIP_JUNCTION_OR, 'o'],
	[CX.RELATIONSHIP_REALIZATION, 'o'],
	[CX.RELATIONSHIP_SERVING, 'o'],
	[CX.RELATIONSHIP_SPECIALIZATION, 'o'],
	[CX.RELATIONSHIP_TRIGGERING, 'o'],
]);

export const RELATIONSHIPS_ALLOWED_FROM_APPLICATION_INTERACTION = new Map([
	[CX.MOTIVATION_ASSESSMENT, 'no'],
	[CX.MOTIVATION_CONSTRAINT, 'rno'],
	[CX.MOTIVATION_DRIVER, 'no'],
	[CX.MOTIVATION_GOAL, 'rno'],
	[CX.MOTIVATION_MEANING, 'no'],
	[CX.MOTIVATION_OUTCOME, 'rno'],
	[CX.MOTIVATION_PRINCIPLE, 'rno'],
	[CX.MOTIVATION_REQUIREMENT, 'rno'],
	[CX.MOTIVATION_STAKEHOLDER, 'no'],
	[CX.MOTIVATION_VALUE, 'no'],
	[CX.STRATEGY_CAPABILITY, 'ro'],
	[CX.STRATEGY_VALUE_STREAM, 'ro'],
	[CX.STRATEGY_COURSE_OF_ACTION, 'ro'],
	[CX.STRATEGY_RESOURCE, 'o'],
	[CX.BUSINESS_ACTOR, 'vtfo'],
	[CX.BUSINESS_COLLABORATION, 'vtfo'],
	[CX.BUSINESS_EVENT, 'vtfo'],
	[CX.BUSINESS_FUNCTION, 'rvtfo'],
	[CX.BUSINESS_INTERACTION, 'rvtfo'],
	[CX.BUSINESS_INTERFACE, 'vtfo'],
	[CX.BUSINESS_OBJECT, 'ao'],
	[CX.BUSINESS_PROCESS, 'rvtfo'],
	[CX.BUSINESS_ROLE, 'vtfo'],
	[CX.BUSINESS_SERVICE, 'rvtfo'],
	[CX.BUSINESS_CONTRACT, 'ao'],
	[CX.BUSINESS_PRODUCT, 'vtfo'],
	[CX.BUSINESS_REPRESENTATION, 'ao'],
	[CX.APPLICATION_COLLABORATION, 'vtfo'],
	[CX.APPLICATION_COMPONENT, 'vtfo'],
	[CX.APPLICATION_EVENT, 'vtfo'],
	[CX.APPLICATION_FUNCTION, 'cgvtfo'],
	[CX.APPLICATION_INTERACTION, 'scgvtfo'],
	[CX.APPLICATION_INTERFACE, 'vtfo'],
	[CX.APPLICATION_PROCESS, 'cgvtfo'],
	[CX.APPLICATION_SERVICE, 'rvtfo'],
	[CX.APPLICATION_DATA_OBJECT, 'ao'],
	[CX.TECHNOLOGY_ARTIFACT, 'ao'],
	[CX.TECHNOLOGY_COMMUNICATION_NETWORK, 'vtfo'],
	[CX.TECHNOLOGY_DEVICE, 'vtfo'],
	[CX.TECHNOLOGY_NODE, 'vtfo'],
	[CX.TECHNOLOGY_PATH, 'vtfo'],
	[CX.TECHNOLOGY_SYSTEM_SOFTWARE, 'vtfo'],
	[CX.TECHNOLOGY_COLLABORATION, 'vtfo'],
	[CX.TECHNOLOGY_EVENT, 'vtfo'],
	[CX.TECHNOLOGY_FUNCTION, 'vtfo'],
	[CX.TECHNOLOGY_INTERACTION, 'vtfo'],
	[CX.TECHNOLOGY_INTERFACE, 'vtfo'],
	[CX.TECHNOLOGY_PROCESS, 'vtfo'],
	[CX.TECHNOLOGY_SERVICE, 'vtfo'],
	[CX.PHYSICAL_DISTRIBUTION_NETWORK, 'vtfo'],
	[CX.PHYSICAL_EQUIPMENT, 'vtfo'],
	[CX.PHYSICAL_FACILITY, 'vtfo'],
	[CX.PHYSICAL_MATERIAL, 'ao'],
	[CX.IMP_MIG_DELIVERABLE, 'o'],
	[CX.IMP_MIG_IMPLEMENTATION_EVENT, 'o'],
	[CX.IMP_MIG_WORK_PACKAGE, 'o'],
	[CX.IMP_MIG_GAP, 'o'],
	[CX.IMP_MIG_PLATEAU, 'o'],
	[CX.OTHER_LOCATION, 'vtfo'],
	[CX.OTHER_GROUPING, 'scgrvantfo'],
	[CX.OTHER_JUNCTION, 'cgirvantfso'],
	[CX.OTHER_AND_JUNCTION, 'cgirvantfso'],
	[CX.OTHER_OR_JUNCTION, 'cgirvantfso'],
	[CX.RELATIONSHIP_ACCESS, 'o'],
	[CX.RELATIONSHIP_AGGREGATION, 'o'],
	[CX.RELATIONSHIP_ASSIGNMENT, 'o'],
	[CX.RELATIONSHIP_ASSOCIATION, 'o'],
	[CX.RELATIONSHIP_COMPOSITION, 'o'],
	[CX.RELATIONSHIP_FLOW, 'o'],
	[CX.RELATIONSHIP_INFLUENCE, 'o'],
	[CX.RELATIONSHIP_JUNCTION_AND, 'o'],
	[CX.RELATIONSHIP_JUNCTION_OR, 'o'],
	[CX.RELATIONSHIP_REALIZATION, 'o'],
	[CX.RELATIONSHIP_SERVING, 'o'],
	[CX.RELATIONSHIP_SPECIALIZATION, 'o'],
	[CX.RELATIONSHIP_TRIGGERING, 'o'],
]);

export const RELATIONSHIPS_ALLOWED_FROM_APPLICATION_INTERFACE = new Map([
	[CX.MOTIVATION_ASSESSMENT, 'no'],
	[CX.MOTIVATION_CONSTRAINT, 'rno'],
	[CX.MOTIVATION_DRIVER, 'no'],
	[CX.MOTIVATION_GOAL, 'rno'],
	[CX.MOTIVATION_MEANING, 'no'],
	[CX.MOTIVATION_OUTCOME, 'rno'],
	[CX.MOTIVATION_PRINCIPLE, 'rno'],
	[CX.MOTIVATION_REQUIREMENT, 'rno'],
	[CX.MOTIVATION_STAKEHOLDER, 'no'],
	[CX.MOTIVATION_VALUE, 'no'],
	[CX.STRATEGY_CAPABILITY, 'ro'],
	[CX.STRATEGY_VALUE_STREAM, 'ro'],
	[CX.STRATEGY_COURSE_OF_ACTION, 'ro'],
	[CX.STRATEGY_RESOURCE, 'ro'],
	[CX.BUSINESS_ACTOR, 'vtfo'],
	[CX.BUSINESS_COLLABORATION, 'vtfo'],
	[CX.BUSINESS_EVENT, 'vtfo'],
	[CX.BUSINESS_FUNCTION, 'vtfo'],
	[CX.BUSINESS_INTERACTION, 'vtfo'],
	[CX.BUSINESS_INTERFACE, 'rvtfo'],
	[CX.BUSINESS_OBJECT, 'ao'],
	[CX.BUSINESS_PROCESS, 'vtfo'],
	[CX.BUSINESS_ROLE, 'vtfo'],
	[CX.BUSINESS_SERVICE, 'rvtfo'],
	[CX.BUSINESS_CONTRACT, 'ao'],
	[CX.BUSINESS_PRODUCT, 'vtfo'],
	[CX.BUSINESS_REPRESENTATION, 'ao'],
	[CX.APPLICATION_COLLABORATION, 'vtfo'],
	[CX.APPLICATION_COMPONENT, 'vtfo'],
	[CX.APPLICATION_EVENT, 'vtfo'],
	[CX.APPLICATION_FUNCTION, 'vtfo'],
	[CX.APPLICATION_INTERACTION, 'vtfo'],
	[CX.APPLICATION_INTERFACE, 'scgvtfo'],
	[CX.APPLICATION_PROCESS, 'vtfo'],
	[CX.APPLICATION_SERVICE, 'ivtfo'],
	[CX.APPLICATION_DATA_OBJECT, 'ao'],
	[CX.TECHNOLOGY_ARTIFACT, 'ao'],
	[CX.TECHNOLOGY_COMMUNICATION_NETWORK, 'vtfo'],
	[CX.TECHNOLOGY_DEVICE, 'vtfo'],
	[CX.TECHNOLOGY_NODE, 'vtfo'],
	[CX.TECHNOLOGY_PATH, 'vtfo'],
	[CX.TECHNOLOGY_SYSTEM_SOFTWARE, 'vtfo'],
	[CX.TECHNOLOGY_COLLABORATION, 'vtfo'],
	[CX.TECHNOLOGY_EVENT, 'vtfo'],
	[CX.TECHNOLOGY_FUNCTION, 'vtfo'],
	[CX.TECHNOLOGY_INTERACTION, 'vtfo'],
	[CX.TECHNOLOGY_INTERFACE, 'vtfo'],
	[CX.TECHNOLOGY_PROCESS, 'vtfo'],
	[CX.TECHNOLOGY_SERVICE, 'vtfo'],
	[CX.PHYSICAL_DISTRIBUTION_NETWORK, 'vtfo'],
	[CX.PHYSICAL_EQUIPMENT, 'vtfo'],
	[CX.PHYSICAL_FACILITY, 'vtfo'],
	[CX.PHYSICAL_MATERIAL, 'ao'],
	[CX.IMP_MIG_DELIVERABLE, 'o'],
	[CX.IMP_MIG_IMPLEMENTATION_EVENT, 'o'],
	[CX.IMP_MIG_WORK_PACKAGE, 'o'],
	[CX.IMP_MIG_GAP, 'o'],
	[CX.IMP_MIG_PLATEAU, 'o'],
	[CX.OTHER_LOCATION, 'vtfo'],
	[CX.OTHER_GROUPING, 'scgirvantfo'],
	[CX.OTHER_JUNCTION, 'cgirvantfso'],
	[CX.OTHER_AND_JUNCTION, 'cgirvantfso'],
	[CX.OTHER_OR_JUNCTION, 'cgirvantfso'],
	[CX.RELATIONSHIP_ACCESS, 'o'],
	[CX.RELATIONSHIP_AGGREGATION, 'o'],
	[CX.RELATIONSHIP_ASSIGNMENT, 'o'],
	[CX.RELATIONSHIP_ASSOCIATION, 'o'],
	[CX.RELATIONSHIP_COMPOSITION, 'o'],
	[CX.RELATIONSHIP_FLOW, 'o'],
	[CX.RELATIONSHIP_INFLUENCE, 'o'],
	[CX.RELATIONSHIP_JUNCTION_AND, 'o'],
	[CX.RELATIONSHIP_JUNCTION_OR, 'o'],
	[CX.RELATIONSHIP_REALIZATION, 'o'],
	[CX.RELATIONSHIP_SERVING, 'o'],
	[CX.RELATIONSHIP_SPECIALIZATION, 'o'],
	[CX.RELATIONSHIP_TRIGGERING, 'o'],
]);

export const RELATIONSHIPS_ALLOWED_FROM_APPLICATION_PROCESS = new Map([
	[CX.MOTIVATION_ASSESSMENT, 'no'],
	[CX.MOTIVATION_CONSTRAINT, 'rno'],
	[CX.MOTIVATION_DRIVER, 'no'],
	[CX.MOTIVATION_GOAL, 'rno'],
	[CX.MOTIVATION_MEANING, 'no'],
	[CX.MOTIVATION_OUTCOME, 'rno'],
	[CX.MOTIVATION_PRINCIPLE, 'rno'],
	[CX.MOTIVATION_REQUIREMENT, 'rno'],
	[CX.MOTIVATION_STAKEHOLDER, 'no'],
	[CX.MOTIVATION_VALUE, 'no'],
	[CX.STRATEGY_CAPABILITY, 'ro'],
	[CX.STRATEGY_VALUE_STREAM, 'ro'],
	[CX.STRATEGY_COURSE_OF_ACTION, 'ro'],
	[CX.STRATEGY_RESOURCE, 'o'],
	[CX.BUSINESS_ACTOR, 'vtfo'],
	[CX.BUSINESS_COLLABORATION, 'vtfo'],
	[CX.BUSINESS_EVENT, 'vtfo'],
	[CX.BUSINESS_FUNCTION, 'rvtfo'],
	[CX.BUSINESS_INTERACTION, 'rvtfo'],
	[CX.BUSINESS_INTERFACE, 'vtfo'],
	[CX.BUSINESS_OBJECT, 'ao'],
	[CX.BUSINESS_PROCESS, 'rvtfo'],
	[CX.BUSINESS_ROLE, 'vtfo'],
	[CX.BUSINESS_SERVICE, 'rvtfo'],
	[CX.BUSINESS_CONTRACT, 'ao'],
	[CX.BUSINESS_PRODUCT, 'vtfo'],
	[CX.BUSINESS_REPRESENTATION, 'ao'],
	[CX.APPLICATION_COLLABORATION, 'vtfo'],
	[CX.APPLICATION_COMPONENT, 'vtfo'],
	[CX.APPLICATION_EVENT, 'vtfo'],
	[CX.APPLICATION_FUNCTION, 'cgvtfo'],
	[CX.APPLICATION_INTERACTION, 'cgvtfo'],
	[CX.APPLICATION_INTERFACE, 'vtfo'],
	[CX.APPLICATION_PROCESS, 'scgvtfo'],
	[CX.APPLICATION_SERVICE, 'rvtfo'],
	[CX.APPLICATION_DATA_OBJECT, 'ao'],
	[CX.TECHNOLOGY_ARTIFACT, 'ao'],
	[CX.TECHNOLOGY_COMMUNICATION_NETWORK, 'vtfo'],
	[CX.TECHNOLOGY_DEVICE, 'vtfo'],
	[CX.TECHNOLOGY_NODE, 'vtfo'],
	[CX.TECHNOLOGY_PATH, 'vtfo'],
	[CX.TECHNOLOGY_SYSTEM_SOFTWARE, 'vtfo'],
	[CX.TECHNOLOGY_COLLABORATION, 'vtfo'],
	[CX.TECHNOLOGY_EVENT, 'vtfo'],
	[CX.TECHNOLOGY_FUNCTION, 'vtfo'],
	[CX.TECHNOLOGY_INTERACTION, 'vtfo'],
	[CX.TECHNOLOGY_INTERFACE, 'vtfo'],
	[CX.TECHNOLOGY_PROCESS, 'vtfo'],
	[CX.TECHNOLOGY_SERVICE, 'vtfo'],
	[CX.PHYSICAL_DISTRIBUTION_NETWORK, 'vtfo'],
	[CX.PHYSICAL_EQUIPMENT, 'vtfo'],
	[CX.PHYSICAL_FACILITY, 'vtfo'],
	[CX.PHYSICAL_MATERIAL, 'ao'],
	[CX.IMP_MIG_DELIVERABLE, 'o'],
	[CX.IMP_MIG_IMPLEMENTATION_EVENT, 'o'],
	[CX.IMP_MIG_WORK_PACKAGE, 'o'],
	[CX.IMP_MIG_GAP, 'o'],
	[CX.IMP_MIG_PLATEAU, 'o'],
	[CX.OTHER_LOCATION, 'vtfo'],
	[CX.OTHER_GROUPING, 'scgrvantfo'],
	[CX.OTHER_JUNCTION, 'cgirvantfso'],
	[CX.OTHER_AND_JUNCTION, 'cgirvantfso'],
	[CX.OTHER_OR_JUNCTION, 'cgirvantfso'],
	[CX.RELATIONSHIP_ACCESS, 'o'],
	[CX.RELATIONSHIP_AGGREGATION, 'o'],
	[CX.RELATIONSHIP_ASSIGNMENT, 'o'],
	[CX.RELATIONSHIP_ASSOCIATION, 'o'],
	[CX.RELATIONSHIP_COMPOSITION, 'o'],
	[CX.RELATIONSHIP_FLOW, 'o'],
	[CX.RELATIONSHIP_INFLUENCE, 'o'],
	[CX.RELATIONSHIP_JUNCTION_AND, 'o'],
	[CX.RELATIONSHIP_JUNCTION_OR, 'o'],
	[CX.RELATIONSHIP_REALIZATION, 'o'],
	[CX.RELATIONSHIP_SERVING, 'o'],
	[CX.RELATIONSHIP_SPECIALIZATION, 'o'],
	[CX.RELATIONSHIP_TRIGGERING, 'o'],
]);

export const RELATIONSHIPS_ALLOWED_FROM_APPLICATION_SERVICE = new Map([
	[CX.MOTIVATION_ASSESSMENT, 'no'],
	[CX.MOTIVATION_CONSTRAINT, 'rno'],
	[CX.MOTIVATION_DRIVER, 'no'],
	[CX.MOTIVATION_GOAL, 'rno'],
	[CX.MOTIVATION_MEANING, 'no'],
	[CX.MOTIVATION_OUTCOME, 'rno'],
	[CX.MOTIVATION_PRINCIPLE, 'rno'],
	[CX.MOTIVATION_REQUIREMENT, 'rno'],
	[CX.MOTIVATION_STAKEHOLDER, 'no'],
	[CX.MOTIVATION_VALUE, 'no'],
	[CX.STRATEGY_CAPABILITY, 'ro'],
	[CX.STRATEGY_VALUE_STREAM, 'ro'],
	[CX.STRATEGY_COURSE_OF_ACTION, 'ro'],
	[CX.STRATEGY_RESOURCE, 'o'],
	[CX.BUSINESS_ACTOR, 'vtfo'],
	[CX.BUSINESS_COLLABORATION, 'vtfo'],
	[CX.BUSINESS_EVENT, 'vtfo'],
	[CX.BUSINESS_FUNCTION, 'vtfo'],
	[CX.BUSINESS_INTERACTION, 'vtfo'],
	[CX.BUSINESS_INTERFACE, 'vtfo'],
	[CX.BUSINESS_OBJECT, 'ao'],
	[CX.BUSINESS_PROCESS, 'vtfo'],
	[CX.BUSINESS_ROLE, 'vtfo'],
	[CX.BUSINESS_SERVICE, 'rvtfo'],
	[CX.BUSINESS_CONTRACT, 'ao'],
	[CX.BUSINESS_PRODUCT, 'vtfo'],
	[CX.BUSINESS_REPRESENTATION, 'ao'],
	[CX.APPLICATION_COLLABORATION, 'vtfo'],
	[CX.APPLICATION_COMPONENT, 'vtfo'],
	[CX.APPLICATION_EVENT, 'vtfo'],
	[CX.APPLICATION_FUNCTION, 'vtfo'],
	[CX.APPLICATION_INTERACTION, 'vtfo'],
	[CX.APPLICATION_INTERFACE, 'vtfo'],
	[CX.APPLICATION_PROCESS, 'vtfo'],
	[CX.APPLICATION_SERVICE, 'scgvtfo'],
	[CX.APPLICATION_DATA_OBJECT, 'ao'],
	[CX.TECHNOLOGY_ARTIFACT, 'ao'],
	[CX.TECHNOLOGY_COMMUNICATION_NETWORK, 'vtfo'],
	[CX.TECHNOLOGY_DEVICE, 'vtfo'],
	[CX.TECHNOLOGY_NODE, 'vtfo'],
	[CX.TECHNOLOGY_PATH, 'vtfo'],
	[CX.TECHNOLOGY_SYSTEM_SOFTWARE, 'vtfo'],
	[CX.TECHNOLOGY_COLLABORATION, 'vtfo'],
	[CX.TECHNOLOGY_EVENT, 'vtfo'],
	[CX.TECHNOLOGY_FUNCTION, 'vtfo'],
	[CX.TECHNOLOGY_INTERACTION, 'vtfo'],
	[CX.TECHNOLOGY_INTERFACE, 'vtfo'],
	[CX.TECHNOLOGY_PROCESS, 'vtfo'],
	[CX.TECHNOLOGY_SERVICE, 'vtfo'],
	[CX.PHYSICAL_DISTRIBUTION_NETWORK, 'vtfo'],
	[CX.PHYSICAL_EQUIPMENT, 'vtfo'],
	[CX.PHYSICAL_FACILITY, 'vtfo'],
	[CX.PHYSICAL_MATERIAL, 'ao'],
	[CX.IMP_MIG_DELIVERABLE, 'o'],
	[CX.IMP_MIG_IMPLEMENTATION_EVENT, 'o'],
	[CX.IMP_MIG_WORK_PACKAGE, 'o'],
	[CX.IMP_MIG_GAP, 'o'],
	[CX.IMP_MIG_PLATEAU, 'o'],
	[CX.OTHER_LOCATION, 'vtfo'],
	[CX.OTHER_GROUPING, 'scgrvantfo'],
	[CX.OTHER_JUNCTION, 'cgirvantfso'],
	[CX.OTHER_AND_JUNCTION, 'cgirvantfso'],
	[CX.OTHER_OR_JUNCTION, 'cgirvantfso'],
	[CX.RELATIONSHIP_ACCESS, 'o'],
	[CX.RELATIONSHIP_AGGREGATION, 'o'],
	[CX.RELATIONSHIP_ASSIGNMENT, 'o'],
	[CX.RELATIONSHIP_ASSOCIATION, 'o'],
	[CX.RELATIONSHIP_COMPOSITION, 'o'],
	[CX.RELATIONSHIP_FLOW, 'o'],
	[CX.RELATIONSHIP_INFLUENCE, 'o'],
	[CX.RELATIONSHIP_JUNCTION_AND, 'o'],
	[CX.RELATIONSHIP_JUNCTION_OR, 'o'],
	[CX.RELATIONSHIP_REALIZATION, 'o'],
	[CX.RELATIONSHIP_SERVING, 'o'],
	[CX.RELATIONSHIP_SPECIALIZATION, 'o'],
	[CX.RELATIONSHIP_TRIGGERING, 'o'],
]);

export const RELATIONSHIPS_ALLOWED_FROM_APPLICATION_DATA_OBJECT = new Map([
	[CX.MOTIVATION_ASSESSMENT, 'no'],
	[CX.MOTIVATION_CONSTRAINT, 'rno'],
	[CX.MOTIVATION_DRIVER, 'no'],
	[CX.MOTIVATION_GOAL, 'rno'],
	[CX.MOTIVATION_MEANING, 'no'],
	[CX.MOTIVATION_OUTCOME, 'rno'],
	[CX.MOTIVATION_PRINCIPLE, 'rno'],
	[CX.MOTIVATION_REQUIREMENT, 'rno'],
	[CX.MOTIVATION_STAKEHOLDER, 'no'],
	[CX.MOTIVATION_VALUE, 'no'],
	[CX.STRATEGY_CAPABILITY, 'ro'],
	[CX.STRATEGY_VALUE_STREAM, 'ro'],
	[CX.STRATEGY_COURSE_OF_ACTION, 'ro'],
	[CX.STRATEGY_RESOURCE, 'ro'],
	[CX.BUSINESS_ACTOR, 'o'],
	[CX.BUSINESS_COLLABORATION, 'o'],
	[CX.BUSINESS_EVENT, 'o'],
	[CX.BUSINESS_FUNCTION, 'o'],
	[CX.BUSINESS_INTERACTION, 'o'],
	[CX.BUSINESS_INTERFACE, 'o'],
	[CX.BUSINESS_OBJECT, 'ro'],
	[CX.BUSINESS_PROCESS, 'o'],
	[CX.BUSINESS_ROLE, 'o'],
	[CX.BUSINESS_SERVICE, 'o'],
	[CX.BUSINESS_CONTRACT, 'ro'],
	[CX.BUSINESS_PRODUCT, 'o'],
	[CX.BUSINESS_REPRESENTATION, 'o'],
	[CX.APPLICATION_COLLABORATION, 'o'],
	[CX.APPLICATION_COMPONENT, 'o'],
	[CX.APPLICATION_EVENT, 'o'],
	[CX.APPLICATION_FUNCTION, 'o'],
	[CX.APPLICATION_INTERACTION, 'o'],
	[CX.APPLICATION_INTERFACE, 'o'],
	[CX.APPLICATION_PROCESS, 'o'],
	[CX.APPLICATION_SERVICE, 'o'],
	[CX.APPLICATION_DATA_OBJECT, 'scgo'],
	[CX.TECHNOLOGY_ARTIFACT, 'o'],
	[CX.TECHNOLOGY_COMMUNICATION_NETWORK, 'o'],
	[CX.TECHNOLOGY_DEVICE, 'o'],
	[CX.TECHNOLOGY_NODE, 'o'],
	[CX.TECHNOLOGY_PATH, 'o'],
	[CX.TECHNOLOGY_SYSTEM_SOFTWARE, 'o'],
	[CX.TECHNOLOGY_COLLABORATION, 'o'],
	[CX.TECHNOLOGY_EVENT, 'o'],
	[CX.TECHNOLOGY_FUNCTION, 'o'],
	[CX.TECHNOLOGY_INTERACTION, 'o'],
	[CX.TECHNOLOGY_INTERFACE, 'o'],
	[CX.TECHNOLOGY_PROCESS, 'o'],
	[CX.TECHNOLOGY_SERVICE, 'o'],
	[CX.PHYSICAL_DISTRIBUTION_NETWORK, 'o'],
	[CX.PHYSICAL_EQUIPMENT, 'o'],
	[CX.PHYSICAL_FACILITY, 'o'],
	[CX.PHYSICAL_MATERIAL, 'o'],
	[CX.IMP_MIG_DELIVERABLE, 'o'],
	[CX.IMP_MIG_IMPLEMENTATION_EVENT, 'o'],
	[CX.IMP_MIG_WORK_PACKAGE, 'o'],
	[CX.IMP_MIG_GAP, 'o'],
	[CX.IMP_MIG_PLATEAU, 'o'],
	[CX.OTHER_LOCATION, 'o'],
	[CX.OTHER_GROUPING, 'scgrno'],
	[CX.OTHER_JUNCTION, 'cgirvantfso'],
	[CX.OTHER_AND_JUNCTION, 'cgirvantfso'],
	[CX.OTHER_OR_JUNCTION, 'cgirvantfso'],
	[CX.RELATIONSHIP_ACCESS, 'o'],
	[CX.RELATIONSHIP_AGGREGATION, 'o'],
	[CX.RELATIONSHIP_ASSIGNMENT, 'o'],
	[CX.RELATIONSHIP_ASSOCIATION, 'o'],
	[CX.RELATIONSHIP_COMPOSITION, 'o'],
	[CX.RELATIONSHIP_FLOW, 'o'],
	[CX.RELATIONSHIP_INFLUENCE, 'o'],
	[CX.RELATIONSHIP_JUNCTION_AND, 'o'],
	[CX.RELATIONSHIP_JUNCTION_OR, 'o'],
	[CX.RELATIONSHIP_REALIZATION, 'o'],
	[CX.RELATIONSHIP_SERVING, 'o'],
	[CX.RELATIONSHIP_SPECIALIZATION, 'o'],
	[CX.RELATIONSHIP_TRIGGERING, 'o'],
]);
